import { useLocation, useNavigate } from 'react-router-dom';

export function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      icon: 'ri-dashboard-line',
      label: 'Ordens de Serviço',
      path: '/dashboard',
      active: location.pathname === '/dashboard'
    },
    {
      icon: 'ri-tools-line',
      label: 'Ativos',
      path: '/assets',
      active: location.pathname === '/assets'
    },
    {
      icon: 'ri-map-pin-line',
      label: 'Localizações',
      path: '/locations',
      active: location.pathname === '/locations'
    },
    {
      icon: 'ri-calendar-check-line',
      label: 'Planos de Manutenção',
      path: '/maintenance-plans',
      active: location.pathname === '/maintenance-plans'
    },
    {
      icon: 'ri-box-3-line',
      label: 'Inventário',
      path: '/inventory',
      active: location.pathname === '/inventory'
    },
    {
      icon: 'ri-file-list-3-line',
      label: 'Procedimentos',
      path: '/procedures',
      active: location.pathname === '/procedures'
    },
    {
      icon: 'ri-bar-chart-box-line',
      label: 'Relatórios',
      path: '/reports',
      active: location.pathname === '/reports'
    }
  ];

  return (
    <aside className="w-64 bg-gray-900 min-h-screen flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-gray-800">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xl">P</span>
          </div>
          <div>
            <h1 className="text-white font-bold text-lg" style={{ fontFamily: '"Pacifico", serif' }}>
              Plano de Manutenção
            </h1>
            <p className="text-gray-400 text-xs">CMMS Platform</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-6">
        <div className="space-y-1">
          {menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors cursor-pointer ${
                item.active
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-800 hover:text-white'
              }`}
            >
              <i className={`${item.icon} text-xl`}></i>
              <span className="font-medium">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>

      {/* User Section */}
      <div className="p-4 border-t border-gray-800">
        <div className="flex items-center space-x-3 px-2">
          <div className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center">
            <i className="ri-user-line text-gray-300 text-lg"></i>
          </div>
          <div className="flex-1">
            <p className="text-white text-sm font-medium">Admin User</p>
            <p className="text-gray-400 text-xs">admin@cmms.com</p>
          </div>
          <button 
            onClick={() => navigate('/login')}
            className="text-gray-400 hover:text-white cursor-pointer"
          >
            <i className="ri-logout-box-line text-lg"></i>
          </button>
        </div>
      </div>
    </aside>
  );
}
